var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 40,
    viewBox: "0 0 303 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9173 2.10704C59.0666 1.67005 59.4781 1 60.6034 1H60.7053H74.2775C75.6978 1.05098 75.9199 2.19808 75.949 2.4275C75.1952 22.7221 58.484 39 37.9745 39C17.4651 39 0.702827 22.6711 0 2.32918C0.0837566 1.93953 0.422425 1.02913 1.74068 1.02913C1.87542 1.02913 1.98467 1.01821 2.07207 1H15.0361C15.1162 1.01092 15.2109 1.01821 15.3238 1.01821C16.562 1.01821 16.937 1.83028 17.0463 2.24907C17.6945 13.2321 26.7875 21.9683 37.9782 21.9683C49.1688 21.9683 58.3383 13.1556 58.9173 2.10704Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5762 10.3539H96.1655V37.0451H103.987V10.3539H114.576V2.82129H85.5762V10.3539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.073 2.82129H118.252V37.0451H126.073V2.82129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.327 23.4522H185.974V16.0255H171.327V10.3539H187.193V2.82129H163.506V37.0451H187.441V29.5183H171.327V23.4522Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.29 2.82129H201.039V37.0451H208.86V26.2909H214.29C221.04 26.2909 226.27 21.061 226.27 14.559C226.27 8.05704 221.04 2.82129 214.29 2.82129ZM216.605 18.1516C215.545 18.8171 213.837 18.9349 213.012 18.9526H208.86V10.1537H213.436C214.314 10.2008 215.645 10.3657 216.546 10.9075C217.689 11.685 218.448 13.0101 218.448 14.559C218.448 16.108 217.718 17.3742 216.611 18.1575",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.495 2.82129H229.674V37.0451H237.495V2.82129Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.168 10.9552C260.777 10.9552 263.274 12.0683 265.024 14.0118L271.007 8.64062C267.739 5.00092 263.062 2.91016 258.168 2.91016C248.657 2.91016 240.924 10.6489 240.924 20.1546C240.924 29.6602 248.663 37.4049 258.168 37.4049C263.015 37.4049 267.668 35.3494 270.931 31.7568L264.982 26.3503C263.239 28.2644 260.76 29.3657 258.168 29.3657C253.092 29.3657 248.963 25.2372 248.963 20.1605C248.963 15.0837 253.092 10.9552 258.168 10.9552Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.977 18.5521L302.615 2.82129H293.333L283.656 15.9077C283.044 15.8194 282.166 15.7487 281.536 15.7134V2.82718H273.715V37.051H281.536V23.8585C283.091 23.9174 284.557 24.1236 285.894 24.8421C290.253 27.1802 293.215 31.7269 293.221 37.0392H301.284C301.284 29.1061 297.267 22.2448 290.989 18.558",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.912 14.6117C158.912 8.10974 153.682 2.87988 146.932 2.87988H131.891V37.1037H139.712V26.3495V26.0314C143.092 26.108 146.09 26.267 148.316 28.4991C150.749 30.9315 151.532 33.8232 151.832 37.1096H159.253C159.253 32.2684 156.833 26.6498 153.811 23.9171C157.009 21.9677 158.906 18.4222 158.906 14.6235M149.153 18.2279C148.134 18.8639 146.526 18.9994 145.678 19.023H139.706V10.2241H145.943C146.744 10.2653 147.957 10.4008 148.864 10.8425H148.876C148.958 10.8896 149.035 10.9308 149.111 10.9779C150.283 11.7553 151.084 13.0746 151.084 14.6176C151.084 16.1607 150.307 17.4387 149.159 18.222",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.949,
    height: 38,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/White.3868a5f5cd4b79cca7350ab8ac5f6612.svg";
export { ForwardRef as ReactComponent };